module.exports = __webpack_public_path__ + "img/headset.b2ea41b2.png";